import { tz } from '@date-fns/tz';
import { format, parseISO } from 'date-fns';
import {
  type DateTimeUTC,
  type IanaId,
  type TimestampDeviceTZ,
  type TimestampUTC,
} from '@common/types/brandedTypes';
import {
  timestampFormatShort,
  utcTimestampFormatShort,
} from '@common/utils/datetime/dateTimeFormats';
import { IanaIdUtc } from '@common/utils/datetime/timezones';

// Parse timestamp as UTC whether it does or does not have the Z suffix present.
export const parseTimestampAsUtc = (
  utcTimestamp: string,
): DateTimeUTC => {
  const timestamp = (utcTimestamp.endsWith('Z'))
    ? utcTimestamp
    : utcTimestamp + 'Z';
  return parseISO(timestamp);
};

export const utcOffset = (
  ianaId: IanaId,
  date = new Date(),
) => format(date, 'xxx', { in: tz(ianaId) });

export const utcNameAndOffset = (
  ianaId: IanaId,
  date = new Date(),
) => format(date, '\'UTC\'xxx', { in: tz(ianaId) });

export const formatAsUtcTimestamp = (date: Date): TimestampUTC =>
  format(date, utcTimestampFormatShort, { in: tz(IanaIdUtc) }) as TimestampUTC;

export const formatAsDeviceTzTimestamp = (date: Date, ianaId: IanaId): TimestampDeviceTZ =>
  format(date, timestampFormatShort, { in: tz(ianaId) }) as TimestampDeviceTZ;
